module.exports = __webpack_public_path__ + "static/media/wine_delivery.d68102f5.jpeg";